module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-scripts/~/node-libs-browser/~/isarray/index.js
 ** module id = 545
 ** module chunks = 0
 **/